import { ORDER_METHODS } from '../../../../../services/exports/Constants';

export default {
  more_info: 'Mehr Info',
  pickup: '{{time}} min Abholung: ',
  delivery: '{{time}} min Lieferung: ',
  labels: {
    available: 'Verfügbar',
    unavailable: 'Nicht verfügbar',
  },
  buttons: {
    order_now: 'Jetzt bestellen',
  },
  order_method_info: {
    fee: {
      [ORDER_METHODS.PICKUP]: 'Abholung: {{fee}}',
      [ORDER_METHODS.DELIVERY]: 'Lieferung: {{fee}}',
      [ORDER_METHODS.ROOM_SERVICE]: 'Vor Ort: {{fee}}',
      [ORDER_METHODS.DINE_IN]: 'Vor Ort: {{fee}}',
    },
    min_order: 'MBW: {{minOrder}}',
  },
  preparation_time: 'Bereit in {{time}} Min oder plane für später',
};
